import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import publications from "../../utils/resources/experiments.json";
import "./Publication.css";
import TEXT from "../../utils/text/publication.json";
import miscTEXT from "../../utils/text/misc.json";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";

export default function Publication() {
  const { pubId } = useParams();
  const { language } = useCurrentLanguage();

  const [publication, setPublication] = useState(null);
  const [pubNotFound, setPubNotFound] = useState(false);

  useEffect(() => {
    setPubNotFound(false);
    const pub = publications.find((pub) => pub.code === pubId);

    if (pub === undefined) setPubNotFound(true);
    else {
      setPubNotFound(false);
      setPublication(pub);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: 'pageview'
    });
  }, []);

  function OverviewContent({ publication }) {
    return (
      <>
        {publication.status ? (
          <p className="pp-sidebar-text">
            <strong>{TEXT["status"][language]}: </strong>
            {publication.status}
          </p>
        ) : null}
        {publication.country ? (
          <p className="pp-sidebar-text">
            <strong>{TEXT["country"][language]}: </strong>
            {publication.country}
          </p>
        ) : null}
        {publication.region ? (
          <p className="pp-sidebar-text">
            <strong>{TEXT["region"][language]}: </strong>
            {publication.region}
          </p>
        ) : null}
        {publication.partners ? (
          <p className="pp-sidebar-text">
            <strong>{TEXT["partners"][language]}: </strong>
            {publication.partners}
          </p>
        ) : null}
        {publication.pubType ? (
          <p className="pp-sidebar-text">
            <strong>{TEXT["type"][language]}: </strong>
            {publication.pubType}
          </p>
        ) : null}
        {publication.author ? (
          <p className="pp-sidebar-text">
            <strong>{TEXT["researchers"][language]}: </strong>
            {publication.author}
          </p>
        ) : null}
      </>
    );
  }

  return pubNotFound ? (
    <h1>{miscTEXT["pubNotFound"][language]}</h1>
  ) : publication ? (
    <div className="pp-container">
      <div className="pp-column-1">
        <div className="pp-title">
          <h1 className="pp-title-text">{publication.title}</h1>
        </div>
        <p className="pp-intro">{publication.description}</p>
        {/* <div className="pp-meta">
          <div className="pp-date">
            <span className="pp-date-text">{publication.date}</span>
          </div>
          <div className="pp-tags">
            <span>{publication.author}</span>
          </div>
          {publication.pdf ? (
            <div className="">
              <a href={publication.pdf}>{miscTEXT["downloadExp"][language]}</a>
            </div>
          ) : null}
        </div> */}
        <div className="pp-sidebar-container">
          <div className="pp-sidebar">
            <div className="pp-sidebar-title">{TEXT["overview"][language]}</div>
            <OverviewContent publication={publication} />
            {publication.pdf ? (
              <div className="pp-download-report">
                <a href={publication.pdf}>
                  {miscTEXT["downloadExp"][language]}
                </a>
              </div>
            ) : null}
          </div>
        </div>
        <div className="pp-pub-content">
          <p className="pp-subtitle">{TEXT["problem"][language]}</p>
          <div className="pp-pub-text">
            {publication.problem.map((text, key) => {
              return <p key={key}>{text}</p>;
            })}
          </div>
          <p className="pp-subtitle">{TEXT["experiment"][language]}</p>
          <div className="pp-pub-text">
            {publication.experiment.map((text, key) => {
              return <p key={key}>{text}</p>;
            })}
          </div>
          <p className="pp-subtitle">{TEXT["methodology"][language]} </p>
          <div className="pp-pub-text">
            {publication.methodology.map((text, key) => {
              return <p key={key}>{text}</p>;
            })}
          </div>
          <p className="pp-subtitle">{TEXT["results"][language]}</p>
          <div className="pp-pub-text">
            {publication.results.map((text, key) => {
              if (typeof text === "string") return <p key={key}>{text}</p>;
              if (text.type === "bulletList")
                return (
                  <ul key={key}>
                    {text.content.map((item, key) => {
                      return <li key={key}>{item}</li>;
                    })}
                  </ul>
                );

              return null;
            })}
          </div>
        </div>
      </div>
      <div className="pp-column-2">
        <div className="pp-sidebar-container">
          <div className="pp-sidebar">
            <div className="pp-sidebar-title">{TEXT["overview"][language]}</div>
            <OverviewContent publication={publication} />
            {publication.pdf ? (
              <div className="pp-download-report">
                <a href={publication.pdf}>
                  {miscTEXT["downloadExp"][language]}
                </a>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
